import { _get, _post } from "./Axios";

export default class MonitoringHasilApi {
  static getList(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("report/list/monitoring?" + params);
  }
  static archieveData(data) {
    return _post("realisasi/arsip", data);
  }
}
